import { useState } from "react";
import { Badge, EmptyState } from "../components/ui";
import { TaxonomyAutocomplete } from "../taxonomy/TaxonomyAutocomplete";
import type { PublicTaxonomyItem } from "../taxonomy/api";

export function MemberTaxonomyPage() {
  const [breed, setBreed] = useState<PublicTaxonomyItem | null>(null);
  const [discipline, setDiscipline] = useState<PublicTaxonomyItem | null>(null);
  const [healthTest, setHealthTest] = useState<PublicTaxonomyItem | null>(null);

  const selected = [breed, discipline, healthTest].filter(
    (item): item is PublicTaxonomyItem => Boolean(item),
  );

  return (
    <section className="page-stack taxonomy-member-page">
      <header className="page-heading">
        <div>
          <p className="eyebrow">Master data</p>
          <h2>Tra cứu giống và danh mục</h2>
          <p>
            Dữ liệu được tải trực tiếp từ API taxonomy. Thành phần này sẽ được dùng lại trong
            form hồ sơ chó, sức khỏe và thành tích.
          </p>
        </div>
        <Badge tone="info">API managed</Badge>
      </header>

      <section className="content-card taxonomy-member-grid" aria-label="Tra cứu taxonomy">
        <TaxonomyAutocomplete
          namespace="breed"
          label="Giống chó"
          placeholder="Nhập Malinois, GSD, Béc-giê…"
          hint="Có thể tìm bằng tên Việt, tên Anh, code hoặc alias."
          value={breed}
          onSelect={setBreed}
        />
        <TaxonomyAutocomplete
          namespace="working_discipline"
          label="Môn làm việc"
          placeholder="Nhập IGP, IPO, SAR…"
          hint="Alias lịch sử vẫn tìm được nhưng item chính luôn được trả về."
          value={discipline}
          onSelect={setDiscipline}
        />
        <TaxonomyAutocomplete
          namespace="health_test"
          label="Health test"
          placeholder="Nhập HD, ED, DM…"
          hint="Danh mục chỉ hỗ trợ nhập liệu, không thay thế tư vấn thú y."
          value={healthTest}
          onSelect={setHealthTest}
        />
      </section>

      {selected.length === 0 ? (
        <EmptyState
          title="Chưa chọn dữ liệu"
          description="Dùng bàn phím hoặc chạm để chọn một item từ danh mục quản trị."
        />
      ) : (
        <section className="content-card selected-taxonomy" aria-live="polite">
          <h3>Dữ liệu đã chọn</h3>
          <div className="selected-taxonomy__list">
            {selected.map((item) => (
              <article key={item.id}>
                <Badge tone="success">{item.namespace}</Badge>
                <strong>{item.nameVi}</strong>
                <span>{item.nameEn ?? "Không có tên tiếng Anh"}</span>
                <code>{item.id}</code>
              </article>
            ))}
          </div>
        </section>
      )}
    </section>
  );
}
